import { Box, Typography } from '@mui/material'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'

const truncateStyle = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const PageTitleDetails = ({ title, wellDetails, showWellDetails }) => {
  const { getLogoColor } = useInnovaTheme()
  const { actualWellName, operator, isPlan } = wellDetails || {}
  const isUsingPlan = Boolean(isPlan)

  if (!title && !showWellDetails) return null

  const wellName = isUsingPlan ? actualWellName || 'No plan selected' : wellDetails?.actualWell || 'No well selected'
  const operatorName = (isUsingPlan ? operator : wellDetails?.operator) || ''
  const line3 = isUsingPlan ? '' : [wellDetails?.rig, wellDetails?.jobNum].filter(Boolean).join(' - ')

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        gap: 1,
      }}>
      {title && (
        <Typography
          sx={{
            ...truncateStyle,
            flexShrink: 1,
            color: '#fff',
            fontSize: 28,
            fontWeight: 600,
            lineHeight: 1.45,
          }}>
          {title}
        </Typography>
      )}

      {showWellDetails && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            minHeight: '40px',
            height: '100%',
            flexShrink: 1000,
            minWidth: 80,
            pl: 1,
            borderLeft: `2px solid ${getLogoColor()}`,
          }}>
          <Typography
            sx={{
              ...truncateStyle,
              color: '#fff',
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 1.25,
              opacity: 1,
            }}>
            {wellName}
          </Typography>
          <Typography
            sx={{
              ...truncateStyle,
              color: '#fff',
              fontSize: 12,
              lineHeight: 1.15,
              opacity: 0.85,
            }}>
            {operatorName}
          </Typography>
          <Typography
            sx={{
              ...truncateStyle,
              color: '#fff',
              fontSize: 12,
              lineHeight: 1.15,
              opacity: 0.85,
            }}>
            {line3}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default PageTitleDetails
